var _style, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000175307375133208963780000008863404884455919511_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1342.6 924.7",
    style: {
      enableBackground: "new 0 0 1342.6 924.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000131342659092078311540000013827178803677089464_);}\n\t.st1{fill:none;stroke:url(#SVGID_00000101813845798339012810000009210231786895721609_);stroke-width:90;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:url(#SVGID_00000000935383525485817600000004978630611283039132_);stroke-width:90;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:url(#SVGID_00000157306147671066981270000016162624724232857500_);stroke-width:90;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:url(#SVGID_00000088822819660611340610000002579271292839488640_);stroke-width:90;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 208.1,
    width: 929,
    height: 509
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 206.1,
    y: 208.1,
    width: 929,
    height: 509
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152970245131015042180000005111385765610074809_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152970245131015042180000005111385765610074809_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039832142583613175920000007865431835428555684_",
    gradientUnits: "userSpaceOnUse",
    x1: -1217.4399,
    y1: -91.8339,
    x2: -802.34,
    y2: -91.8339,
    gradientTransform: "matrix(6.123234e-17 1 1 -6.123234e-17 1226.8939 1472.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#476DFE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#476DFE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000039832142583613175920000007865431835428555684_)",
      strokeWidth: 90,
      strokeMiterlimit: 10
    },
    cx: 1135.1,
    cy: 462.3,
    r: 162.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172400305851573984380000018206496554259312512_",
    gradientUnits: "userSpaceOnUse",
    x1: 553,
    y1: 802.1561,
    x2: 968.1,
    y2: 802.1561,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 1009.7061 1222.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#476DFE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#476DFE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000172400305851573984380000018206496554259312512_)",
      strokeWidth: 90,
      strokeMiterlimit: 10
    },
    cx: 207.6,
    cy: 462.3,
    r: 162.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150788591390937311110000014095516772631735721_",
    gradientUnits: "userSpaceOnUse",
    x1: -779.4,
    y1: 1958.926,
    x2: -364.3,
    y2: 1958.926,
    gradientTransform: "matrix(1 0 0 -1 1242.98 2166.4761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#476DFE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#476DFE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000150788591390937311110000014095516772631735721_)",
      strokeWidth: 90,
      strokeMiterlimit: 10
    },
    cx: 671.1,
    cy: 207.6,
    r: 162.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016773814032406193340000016060927314412026782_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.61,
    y1: -1248.5939,
    x2: 529.71,
    y2: -1248.5939,
    gradientTransform: "matrix(-1 0 0 1 993.29 1965.7139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#476DFE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#476DFE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000016773814032406193340000016060927314412026782_)",
      strokeWidth: 90,
      strokeMiterlimit: 10
    },
    cx: 671.1,
    cy: 717.1,
    r: 162.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.6b608503578de21b23b3548d4a884bbb.svg";
export { ForwardRef as ReactComponent };